var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-container"},[_c('button',{staticClass:"cell-action",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.btnClickedHandler($event)}}},[_vm._v(" A-MIS Link ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }